import { Button, Checkbox, Form, Input, Radio, Select, message, Modal, Tag } from "antd";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { selectSchoolId } from "../../../../../redux/slices/auth.slice";
import { defaultStatus, feeType } from "../../../../../helper/options";
import { serverUrl } from "../../../../../nestserver";
import FeeTable from "./FeeTable";
import BackButton from "../../../../../components/buttons/BackButton";

const AddEditFeeTemplate = () => {
  let { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const [form] = Form.useForm();
  let isFeeTemplate = true;
  const { Option } = Select;
  const [otherFields, setOtherFields] = useState([{}]);
  const [categories, setCategories] = useState([]);
  const [feeResponse, setFeeResponse] = useState();
  const [selectedYearr, setSelectedYearr] = useState(null);
  const [academicStartDate, setAcademicStartDate] = useState(null);
  const [academicEndDate, setAcademicEndDate] = useState(null);
  const [destinationFees, setDestinationFees] = useState([]);
  const [paymentMode, setPaymentMode] = useState("termly");
  const [data, setData] = useState({
    tution: "",
  });

  const disable = feeResponse?.status === "applied";

  const [ackModalVisible, setAckModalVisible] = useState(false);
  const [ack1, setAck1] = useState(false);
  const [ack2, setAck2] = useState(false);

  const computeInstallmentCount = (mode, startDate, endDate) => {
    if (mode === "yearly") return 1;
    if (mode === "quarterly") return 4;
    if (mode === "monthly") {
      if (!startDate || !endDate) return 12;
      const start = moment.isMoment(startDate) ? startDate : moment(startDate);
      const end = moment.isMoment(endDate) ? endDate : moment(endDate);
      return Math.max(1, Math.min(12, Math.ceil(end.diff(start, "months", true))));
    }
    return null;
  };

  const paymentModeLabel = (mode, startDate, endDate) => {
    if (mode === "yearly") return "1 installment — full year bulk payment";
    if (mode === "quarterly") return "4 installments — every quarter";
    if (mode === "monthly") {
      const count = computeInstallmentCount("monthly", startDate, endDate);
      return `${count} installment${count !== 1 ? "s" : ""} — one per month`;
    }
    return null;
  };

  const addOtherField = () => {
    setOtherFields([
      ...otherFields,
      { value: "", label: "", index: otherFields.length },
    ]);

    form.setFieldsValue({
      [`otherField_${otherFields.length}`]: "",
    });
  };

  const removeOtherField = (index) => {
    const newFields = [...otherFields];
    newFields.splice(index, 1);
    setOtherFields(newFields);
  };

  const handleFeeData = (paramName, value) => {
    setData({ ...data, [paramName]: value });
  };
  const fetchClasses = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const classes = useQuery("classes", fetchClasses);

  const schoolId = useSelector(selectSchoolId);
  const { data: schoolData } = useQuery(
    ["school", schoolId],
    () => axios.get(`${serverUrl}/school/${schoolId}`, {
      headers: { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` },
    }).then((r) => r.data),
    { enabled: !!schoolId, staleTime: 5 * 60 * 1000 },
  );
  const isManualMode = schoolData?.result?.data?.is_manual_fee_assignment_enabled === true;

  const handleOtherFieldChange = (value, index, field) => {
    const newFields = [...otherFields];
    newFields[index] = {
      ...newFields[index],
      [field]: value,
    };
    setOtherFields(newFields);
    if (field === "value") {
      form.setFieldsValue({
        [`otherField_${index}`]: value,
      });
    }
  };
  const fetchFeeTemplate = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/admin/fee-template/" + id,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const applyFeeTemplate = async () => {
    try {
      const response = await axios.patch(
        `${serverUrl}/admin/fee-template/${id}/apply/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        }
      );
      const feeResponse = await fetchFeeTemplate();
      setFeeResponse(feeResponse?.result);
      message.success(response?.data?.result?.message);
    } catch (err) {
      if (err?.response?.data?.error?.errors) {
        message.error(err?.response?.data?.error?.errors);
      } else {
        message.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const confirmApplyTemplate = () => {
    Modal.confirm({
      title: "Final Confirmation",
      content: "Once applied, this fee template cannot be edited or deleted throughout the academic year. Are you sure you want to proceed?",
      okText: "Apply",
      cancelText: "Cancel",
      onOk: () => {
        applyFeeTemplate();
      },
    });
  };

  const handleApplyClick = () => {
    setAck1(false);
    setAck2(false);
    setAckModalVisible(true);
  };

  function disabledDate(current) {
    if (!current) return false;
    let effectiveStart = academicStartDate ? moment(academicStartDate) : null;
    let effectiveEnd = academicEndDate ? moment(academicEndDate) : null;
    // Derive from year string when class-based dates are unavailable (e.g. transportation)
    if (!effectiveStart) {
      const yearStr = String(feeResponse?.year || selectedYearr || "");
      const startYr = parseInt(yearStr.split("-")[0]);
      if (!isNaN(startYr)) {
        effectiveStart = moment(`${startYr}-06-01`);
        if (!effectiveEnd) effectiveEnd = moment(`${startYr + 1}-05-31`);
      }
    }
    if (effectiveStart && current < moment(effectiveStart).startOf("day")) return true;
    if (effectiveEnd && current > moment(effectiveEnd).endOf("day")) return true;
    return false;
  }

  const billingZones = useQuery(["transport-billing-zones", id], async () => {
    const params = new URLSearchParams({ excludeApplied: "true" });
    if (id) params.set("templateId", id);
    const res = await axios({
      method: "get",
      url: `${serverUrl}/admin/transport-billing-zone/list?${params.toString()}`,
      headers: { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` },
    });
    return res.data?.result || [];
  });


  const handleDestinationFeeChange = (destination_id, value) => {
    setDestinationFees((prev) =>
      prev.map((d) =>
        d.destination_id === destination_id
          ? { ...d, fee_amount: value }
          : d
      )
    );
  };

  const getTemplateDetails = async () => {
    if (id) {
      try {
        const response = await fetchFeeTemplate();
        setFeeResponse(response?.result);
        const tuitionComp = response?.result?.fee_components?.find(
          (comp) => comp.name?.toLowerCase() === "tution"
        );
        const isTutionLike = ["tution", "daycare"].includes(response?.result?.type?.toLowerCase());
        const displayedTotal = isTutionLike && tuitionComp
          ? Number(tuitionComp.amount)
          : response?.result?.total;

        const loadedStart = response?.result?.academic_start_date
          ? moment(response?.result?.academic_start_date)
          : response?.result?.class?.academic_start_date
          ? moment(response?.result?.class?.academic_start_date)
          : null;
        const loadedEnd = response?.result?.academic_end_date
          ? moment(response?.result?.academic_end_date)
          : response?.result?.class?.academic_end_date
          ? moment(response?.result?.class?.academic_end_date)
          : null;
        setAcademicStartDate(loadedStart);
        setAcademicEndDate(loadedEnd);
        setSelectedYearr(loadedStart ? loadedStart.year() : null);

        // Migrate existing transportation templates that have no installments yet
        const result = response?.result;
        if (
          result?.type === "transportation" &&
          !(result?.installment_list?.length > 0) &&
          result?.installment_count > 0 &&
          parseFloat(result?.destination_fees?.[0]?.fee_amount) > 0 &&
          result?.status !== "applied"
        ) {
          try {
            await axios({
              method: "patch",
              url: `${serverUrl}/admin/fee-template/${id}`,
              headers: { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` },
              data: {
                type: "transportation",
                title: result.title,
                year: result.year,
                due_date: result.due_date,
                academic_start_date: result.academic_start_date,
                academic_end_date: result.academic_end_date,
                installment_count: result.installment_count,
                payment_mode: result.payment_mode || "termly",
                fee_components: [],
                destination_fees: (result.destination_fees || []).map((d) => ({
                  destination_id: d.destination_id?._id || d.destination_id,
                  fee_amount: d.fee_amount,
                })),
                discount: 0,
              },
            });
            const refreshed = await fetchFeeTemplate();
            setFeeResponse(refreshed?.result);
          } catch (e) {
            console.error("Failed to migrate transportation installments:", e?.message);
          }
        }

        form.setFieldsValue({
          title: response?.result?.title,
          total: displayedTotal,
          year: moment(response?.result?.year),
          due_date: moment(response?.result?.due_date),
          installment_count: response?.result?.installment_count,
          fee_components: response?.result?.fee_components,
        });
        if (response?.result?.payment_mode) {
          setPaymentMode(response.result.payment_mode);
        }
        if (type !== "transportation") {
          form.setFieldsValue({
            class: response?.result?.class?._id,
          });
        }
        // Load per-destination fees for transportation templates.
        if (
          response?.result?.type === "transportation" &&
          Array.isArray(response?.result?.destination_fees) &&
          response?.result?.destination_fees.length > 0
        ) {
          setDestinationFees(
            response.result.destination_fees.map((d) => ({
              destination_id: d.destination_id?._id ?? d.destination_id,
              name: d.destination_id?.name ?? "",
              fee_amount: d.fee_amount ?? "",
            }))
          );
        }
        const updatedData = response?.result.fee_components.reduce(
          (acc, curr, index) => {
            if (curr.name === feeType.tution) {
              acc.tution = curr.amount;
            } else if (curr.name === feeType.other) {
              acc.other = curr.amount;
            } else {
              acc.otherFields.push({
                label: curr.name,
                value: curr.amount,
                index,
              });
            }
            return acc;
          },
          { tution: "", other: "", otherFields: [] }
        );
        updatedData.otherFields.forEach((field, index) => {
          form.setFieldsValue({
            [`otherField_${index}`]: field.value,
          });
        });

        setOtherFields([...updatedData.otherFields]);
        form.setFieldsValue({
          tution: updatedData.tution,
          other: updatedData.other,
        });
        setData({
          tution: updatedData.tution,
          other: updatedData.other,
        });

        // Load fee categories if present
        if (Array.isArray(response?.result?.categories) && response.result.categories.length > 0) {
          setCategories(response.result.categories.map((c) => ({
            name: c.name || "",
            tuition_amount: c.tuition_amount != null ? String(c.tuition_amount) : "",
          })));
        }
      } catch (err) {
        console.error("Error fetching template details:", err);
      }
    }
  };

  useEffect(() => {
    getTemplateDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    const sharedTotal = otherFields.reduce((total, field) => {
      const value = parseFloat(field?.value) || 0;
      return total + value;
    }, 0);
    // When categories are defined, use first category's amount as the reference tuition
    const tuition = categories.length > 0
      ? (parseFloat(categories[0]?.tuition_amount) || 0)
      : (parseFloat(data.tution) || 0);

    const total = tuition + sharedTotal;
    if (total === 0) {
      form.setFieldsValue({ total: "" });
    } else {
      form.setFieldsValue({ total: total.toFixed(2) });
    }
  }, [data.tution, otherFields, categories, type, form]);

  const editFeeTemplate = async (values) => {
    try {
      let payload;

      const resolvedInstallmentCount =
        paymentMode === "termly"
          ? values.installment_count
          : computeInstallmentCount(
              paymentMode,
              academicStartDate,
              academicEndDate
            );

      if (type === "transportation") {
        const zone = destinationFees[0];
        if (!zone || !parseFloat(zone.fee_amount) > 0) {
          message.error("Fee amount for the zone must be greater than zero.");
          return;
        }
        payload = {
          type,
          title: values.title,
          year: feeResponse?.year || (academicStartDate ? moment(academicStartDate).format("YYYY") : null),
          due_date: moment(values.due_date).format("YYYY-MM-DD"),
          academic_start_date: academicStartDate ? moment(academicStartDate).format("YYYY-MM-DD") : null,
          academic_end_date: academicEndDate ? moment(academicEndDate).format("YYYY-MM-DD") : null,
          installment_count: resolvedInstallmentCount,
          payment_mode: paymentMode,
          fee_components: [],
          destination_fees: [{ destination_id: zone.destination_id, fee_amount: parseFloat(zone.fee_amount) || 0 }],
          discount: 0,
        };
      } else {
        const validCategories = categories.filter(
          (c) => c.name && Number(c.tuition_amount) > 0
        );
        // When categories exist, use first category's tuition as the reference for installment computation
        const referenceTuition = validCategories.length > 0
          ? Number(validCategories[0].tuition_amount)
          : (Number(data.tution) || 0);

        const feeComponentsData = [
          ...(referenceTuition > 0 && feeType.tution
            ? [{ name: feeType.tution, amount: referenceTuition }]
            : []),
          ...otherFields
            .filter((field) => field.label && Number(field.value) > 0)
            .map((field) => ({
              name: field.label,
              amount: Number(field.value),
            })),
        ];

        const computedTotal = feeComponentsData.reduce(
          (sum, item) => sum + item.amount,
          0
        );
        if (computedTotal <= 0) {
          message.error("Total fee amount must be greater than zero.");
          return;
        }

        payload = {
          type,
          class: values.class,
          title: values.title,
          year: feeResponse?.year || (academicStartDate ? moment(academicStartDate).format("YYYY") : null),
          due_date: moment(values.due_date).format("YYYY-MM-DD"),
          academic_start_date: academicStartDate ? moment(academicStartDate).format("YYYY-MM-DD") : null,
          academic_end_date: academicEndDate ? moment(academicEndDate).format("YYYY-MM-DD") : null,
          installment_count: resolvedInstallmentCount,
          payment_mode: paymentMode,
          fee_components: feeComponentsData,
          total: computedTotal,
          discount: 0,
          ...(validCategories.length > 0 && {
            categories: validCategories.map((c) => ({
              name: c.name,
              tuition_amount: Number(c.tuition_amount),
            })),
          }),
        };
      }

      const response = await axios({
        method: "patch",
        url: `${serverUrl}/admin/fee-template/${id}`,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
        data: payload,
      });

      if (response.data) {
        message.success("Fee template updated successfully");
        await getTemplateDetails();
      }
    } catch (err) {
      if (err?.response?.data?.error?.errors) {
        message.error(err?.response?.data?.error?.errors);
      } else {
        message.error("Failed to update fee template");
      }
      console.error("Error updating fee template:", err);
    }
  };

  return (
    <div>
      <div className="p-4 mt-8 pt-0">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md w-full p-4 "
        >
          {feeResponse?.status === defaultStatus?.pending ? (
            <div className="text-sm font-semibold">
              <span className="text-base font-semibold">CAUTION:-</span>
              Fee Template once applied for a class cannot be modified/deleted
              through-out the Academic year. Please check the fee structure and
              No terms for fee collection and proceed" Click on OK opens the
              pop-up again (Secondary Pop-up) with Apply Template and Cancel
            </div>
          ) : (
            <div className="text-sm font-semibold">
              **<span className="text-base font-semibold">NOTE:-</span>The
              Applied templates are NOT editable/deletable for the complete year
              - If you wish to modify the fee for individual student following
              the path below" Menu - Manage Fee -Classes - Select class - View
              Individual Student{" "}
            </div>
          )}
          <div>
            <div className="p-4 text-right">
              <BackButton />
            </div>
            <div className="p-4" style={{ width: "60%" }}>
              <Form
                form={form}
                name="basic"
                autoComplete="off"
                layout="vertical"
                onFinish={editFeeTemplate}
              >
                <Form.Item
                  label="Title"
                  name="title"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "Title is required",
                    },
                  ]}
                >
                  <Input readOnly={disable} />
                </Form.Item>

                {type !== "transportation" && (
                  <Form.Item
                    label="Class"
                    name="class"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please select a class",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      showArrow
                      placeholder="Select Class"
                      className="w-full bg-gray-300"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabled={disable}
                      onChange={(value) => {
                        const selectedClass = classes?.data?.find(
                          (c) => c._id === value
                        );
                        if (selectedClass) {
                          const startMoment = selectedClass.academic_start_date
                            ? moment(selectedClass.academic_start_date)
                            : null;
                          const endMoment = selectedClass.academic_end_date
                            ? moment(selectedClass.academic_end_date)
                            : null;
                          setAcademicStartDate(startMoment);
                          setAcademicEndDate(endMoment);
                          setSelectedYearr(startMoment ? startMoment.year() : null);
                        }
                      }}
                    >
                      {classes?.isSuccess &&
                        classes?.data?.map((data) => {
                          return (
                            <Option key={data?._id} value={data?._id}>
                              {data?.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                )}

                {type !== "transportation" && !isManualMode && (
                  <Form.Item
                    name="tution"
                    label="Fee"
                    className="w-30"
                    rules={[
                      {
                        required: true,
                        message: " Fee is required",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      onChange={(e) => {
                        handleFeeData("tution", e.target.value);
                      }}
                      onWheel={(e) => e.target.blur()}
                      readOnly={disable}
                    />
                  </Form.Item>
                )}
                {type !== "transportation" &&
                  otherFields &&
                  otherFields.length > 0 &&
                  otherFields?.map((field, index) => (
                    <div key={index} className=" space-x-5 mb-2">
                      <h6 key={index} className="mb-8px capitalize">
                        {field?.label}
                      </h6>
                      <div className="flex items-center ml-0px space-x-4 other-feild">
                        <Input
                          value={field.label}
                          onChange={(e) => {
                            const value = e.target.value;
                            const capitalizedValue =
                              value.charAt(0).toUpperCase() + value.slice(1);
                            handleOtherFieldChange(
                              capitalizedValue,
                              index,
                              "label"
                            );
                          }}
                          readOnly={disable}
                          placeholder="Enter title"
                          className="w-30"
                        />
                        <Input
                          value={field.value}
                          onChange={(e) =>
                            handleOtherFieldChange(
                              e.target.value,
                              index,
                              "value"
                            )
                          }
                          readOnly={disable}
                          className="w-30"
                          placeholder="Enter amount"
                          type="number"
                          min={0}
                          onWheel={(e) => e.target.blur()}
                        />
                        {feeResponse?.status !== "applied" && (
                          <Button
                            type="danger"
                            onClick={() => removeOtherField(index)}
                          >
                            Remove
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
                {type !== "transportation" && type !== "accommodation" && feeResponse?.status !== "applied" && (
                  <div className="pb-4">
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={addOtherField}
                      className="mb-2"
                    >
                      Add
                    </Button>
                  </div>
                )}
                {type === "tution" && isManualMode && (
                  <div className="mb-4 mt-2 border border-gray-200 rounded-md p-4">
                    <div className="flex items-center justify-between mb-3">
                      <h6 className="font-semibold text-gray-700 m-0">
                        Fee Categories{" "}
                        <span className="font-normal text-gray-400 text-xs">(optional — for multiple fee tiers)</span>
                      </h6>
                      {feeResponse?.status !== "applied" && (
                        <Button
                          size="small"
                          type="dashed"
                          onClick={() =>
                            setCategories([
                              ...categories,
                              { name: `Category ${categories.length + 1}`, tuition_amount: "" },
                            ])
                          }
                        >
                          + Add Category
                        </Button>
                      )}
                    </div>
                    {categories.length === 0 && (
                      <p className="text-gray-400 text-sm m-0">
                        No categories added. Add categories to offer different tuition tiers within this template.
                      </p>
                    )}
                    {categories.map((cat, idx) => (
                      <div key={idx} className="flex items-center gap-3 mb-2">
                        <Input
                          placeholder="Category name"
                          value={cat.name}
                          readOnly={feeResponse?.status === "applied"}
                          onChange={(e) => {
                            const updated = [...categories];
                            updated[idx] = { ...updated[idx], name: e.target.value };
                            setCategories(updated);
                          }}
                          style={{ flex: 2 }}
                        />
                        <Input
                          placeholder="Tuition amount (₹)"
                          type="number"
                          min={0}
                          value={cat.tuition_amount}
                          readOnly={feeResponse?.status === "applied"}
                          onChange={(e) => {
                            const updated = [...categories];
                            updated[idx] = { ...updated[idx], tuition_amount: e.target.value };
                            setCategories(updated);
                          }}
                          onWheel={(e) => e.target.blur()}
                          style={{ flex: 1 }}
                        />
                        {feeResponse?.status !== "applied" && (
                          <Button
                            danger
                            size="small"
                            onClick={() => setCategories(categories.filter((_, i) => i !== idx))}
                          >
                            Remove
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {type === "transportation" && (
                  <>
                    {destinationFees[0] && (() => {
                      const zone = (billingZones.data || []).find(
                        (z) => z._id?.toString() === destinationFees[0].destination_id?.toString()
                      );
                      const destinations = zone?.destinations || [];
                      return (
                        <div className="mb-4">
                          <Form.Item label="Billing Zone">
                            <Input
                              readOnly
                              value={destinationFees[0].name}
                              style={{ background: "#EBEBEB", cursor: "default" }}
                            />
                          </Form.Item>
                          {destinations.length > 0 && (
                            <Form.Item label="Destinations in this Zone">
                              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                {destinations.map((dest) => (
                                  <Tag key={dest._id} color="blue">
                                    {dest.name} — ₹{Number(dest.amount).toLocaleString("en-IN")}
                                  </Tag>
                                ))}
                              </div>
                            </Form.Item>
                          )}
                          <Form.Item label="Annual Fee (₹)">
                            <span className="font-semibold">
                              ₹{Number(destinationFees[0].fee_amount || 0).toLocaleString("en-IN")}
                            </span>
                          </Form.Item>
                        </div>
                      );
                    })()}
                  </>
                )}
                {type !== "transportation" && (
                  <Form.Item name="total" label="Total Amount" className="w-30">
                    <Input readOnly />
                  </Form.Item>
                )}
                <Form.Item label="Academic Year" className="w-30">
                  <Input
                    readOnly
                    value={
                      type === "transportation"
                        ? (feeResponse?.year || "—")
                        : selectedYearr
                          ? `${selectedYearr}-${String(selectedYearr + 1).slice(-2)}`
                          : "—"
                    }
                    style={{ background: "#EBEBEB", cursor: "default" }}
                  />
                </Form.Item>
                <Form.Item name="due_date" label="Due Date" className="w-30">
                  <DatePicker
                    format="DD-MM-YYYY"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Due date is required",
                      },
                    ]}
                    disabledDate={disabledDate}
                    disabled={disable}
                  />
                </Form.Item>
                <Form.Item label="Payment Mode" className="w-30">
                  <Radio.Group
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                    optionType="button"
                    buttonStyle="solid"
                    size="small"
                    disabled={disable}
                  >
                    <Radio.Button value="monthly">Monthly</Radio.Button>
                    <Radio.Button value="quarterly">Quarterly</Radio.Button>
                    <Radio.Button value="termly">Termly</Radio.Button>
                    <Radio.Button value="yearly">Yearly</Radio.Button>
                  </Radio.Group>
                  {paymentMode !== "termly" && (
                    <div style={{ marginTop: 6, fontSize: 12, color: "#1890ff" }}>
                      {paymentModeLabel(
                        paymentMode,
                        form.getFieldValue("academic_start_date"),
                        form.getFieldValue("academic_end_date")
                      )}
                    </div>
                  )}
                </Form.Item>
                {paymentMode === "termly" && (
                  <Form.Item
                    name="installment_count"
                    label="Number of terms (Max 12)"
                    className="w-30"
                    rules={[
                      { required: true, message: "Number of terms is required" },
                      {
                        validator: (_, value) => {
                          if (value && (value < 1 || value > 12)) {
                            return Promise.reject(
                              "Number of terms should be between 1 and 12"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder="Enter number of terms"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      readOnly={disable}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Form.Item>
                )}
                {feeResponse?.status !== "applied" && (
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Save Changes
                    </Button>
                  </Form.Item>
                )}
              </Form>
              {feeResponse &&
                feeResponse?.type !== "accommodation" &&
                feeResponse?.status === defaultStatus?.pending && (
                  <div className="flex justify-center items-center py-5">
                    <div className="inline-flex items-center space-x-2">
                      <Button
                        size="large"
                        type="primary"
                        htmlType="button"
                        className="text-white"
                        onClick={handleApplyClick}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                )}
            </div>
            <FeeTable
              feeResponse={feeResponse}
              setFeeResponse={setFeeResponse}
              isFeeTemplate={isFeeTemplate}
              fetchFeeTemplate={fetchFeeTemplate}
              academicStartDate={academicStartDate}
              academicEndDate={academicEndDate}
            />
          </div>
        </div>
      </div>
      <Modal
        title="Acknowledgement Required"
        visible={ackModalVisible}
        onCancel={() => setAckModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setAckModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            disabled={!ack1 || !ack2}
            onClick={() => {
              setAckModalVisible(false);
              confirmApplyTemplate();
            }}
          >
            Apply
          </Button>,
        ]}
      >
        <p style={{ marginBottom: 16 }}>
          Please read and confirm the following before applying this fee template:
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 20, lineHeight: "1.8" }}>
          <li>
            These are <strong>annual fees</strong> applicable for the entire
            academic year. All students in the selected class will be assigned
            this fee structure immediately upon applying.
          </li>
          <li style={{ marginTop: 8 }}>
            Once applied, this fee template <strong>cannot be edited or
            deleted</strong> throughout the academic year. Fee adjustments for
            individual students can only be made through the student fee
            management page.
          </li>
        </ul>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Checkbox checked={ack1} onChange={(e) => setAck1(e.target.checked)}>
            I confirm that these are annual fees for the academic year and all
            amounts are correct.
          </Checkbox>
          <Checkbox checked={ack2} onChange={(e) => setAck2(e.target.checked)}>
            I understand this action is irreversible and the template cannot be
            modified once applied.
          </Checkbox>
        </div>
      </Modal>
    </div>
  );
};

export default AddEditFeeTemplate;
